import React from "react";
import ProjectBlockTypeSwitcher from "./ProjectBlockTypeSwitcher";
import {
    createEmptyTextBlock,
    createEmptyCodeBlock,
    createEmptyLinkBlock,
} from "../../shared/factories";
import Button from "../../../../../../components/elements/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown, faArrowUp, faTrash} from "@fortawesome/free-solid-svg-icons";

export default function ProjectBlocksArrayEditor({ blocks, onChange }) {
    const addBlock = (type) => {
        const next = blocks.slice();
        if (type === "text") next.push(createEmptyTextBlock());
        else if (type === "code") next.push(createEmptyCodeBlock());
        else if (type === "link") next.push(createEmptyLinkBlock());
        else {
            window.alert(`Unsupported block type: ${type}`);
            return;
        }
        onChange(next);
    };

    const deleteBlock = (index) => {
        const next = blocks.filter((_, i) => i !== index);
        onChange(next);
    };

    const moveBlock = (from, to) => {
        if (to < 0 || to >= blocks.length) return;
        const next = blocks.slice();
        const [item] = next.splice(from, 1);
        next.splice(to, 0, item);
        onChange(next);
    };

    const updateBlock = (index, partialBlock) => {
        const next = blocks.slice();

        next[index] = {
            ...blocks[index],      // preserve id + ty
            ...partialBlock,       // merge returned object
            config: {
                ...blocks[index].config,
                ...partialBlock.config,
            },
        };

        onChange(next);
    };


    return (
        <div style={{ display: "grid", gap: 8 }}>
            <div className='flex gap-4 mt-2 mb-5'>
                <Button onClick={() => addBlock("text")}>Text</Button>
                <Button onClick={() => addBlock("code")}>Code</Button>
                <Button onClick={() => addBlock("link")}>Link</Button>
            </div>

            {blocks.length === 0 ? (
                <div className='text-md'>No blocks</div>
            ) : (
                blocks.map((block, index) => (
                    <div
                        key={block.id || index}
                        style={{
                            border: "1px solid #eee",
                            borderRadius: 8,
                            padding: 10,
                            display: "grid",
                            gap: 8,
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <div style={{ fontSize: 12, opacity: 0.7 }}>
                                {index + 1}. {block.type} {block.id ? `(${block.id})` : ""}
                            </div>
                            <div style={{ flex: 1 }} />
                            <button type="button" onClick={() => moveBlock(index, index - 1)}>
                                <FontAwesomeIcon icon={faArrowUp} size={'lg'} />
                            </button>
                            <button type="button" onClick={() => moveBlock(index, index + 1)}>
                                <FontAwesomeIcon icon={faArrowDown} size={'lg'} />
                            </button>
                            <button type="button" onClick={() => deleteBlock(index)}>
                                <FontAwesomeIcon icon={faTrash} size={'lg'} />
                            </button>
                        </div>

                        <ProjectBlockTypeSwitcher
                            block={block}
                            onChange={(next) => updateBlock(index, next)}
                        />
                    </div>
                ))
            )}
        </div>
    );
}
